import { supabase } from "./supabase";
export interface CatchupCandidate {
  contact_id: string;
  name: string;
  email: string | null;
  account_id: string;
  acquired_on: string;
  prior_matching_email_at: string | null;
  exclusion: string | null;
}
export interface CatchupPreview {
  batch_id: string;
  expires_at: string;
  candidates: CatchupCandidate[];
}
export interface CatchupResult {
  contact_id: string;
  outcome: string;
}
export async function previewProductCatchup(
  sequenceId: string,
  from: string,
  to: string,
): Promise<CatchupPreview> {
  const { data, error } = await supabase.rpc(
    "preview_product_journey_catchup",
    { p_sequence: sequenceId, p_from: from, p_to: to },
  );
  if (error) {
    throw error;
  }
  return data;
}
export async function approveProductCatchup(
  batchId: string,
  contacts: string[],
): Promise<CatchupResult[]> {
  const { data, error } = await supabase.rpc(
    "approve_product_journey_catchup",
    { p_batch: batchId, p_contacts: contacts },
  );
  if (error) {
    throw error;
  }
  return data;
}
interface ProductJourneyActivity {
  id: string;
  observed_at: string;
  added_products: string[];
  removed_products: string[];
  status: string;
  last_error: string | null;
  product_sequence_decisions: {
    sequence_id: string;
    outcome: string;
    contact_id: string;
    contacts: { first_name: string | null; last_name: string | null } | null;
  }[];
}
export async function getProductJourneyActivity(sequenceId: string) {
  const { data, error } = await supabase
    .from("account_product_changes")
    .select(
      "id,observed_at,added_products,removed_products,status,last_error,product_sequence_decisions(sequence_id,outcome,contact_id,contacts(first_name,last_name))",
    )
    .contains("sequence_ids", [sequenceId])
    .order("observed_at", { ascending: false })
    .limit(30)
    .returns<ProductJourneyActivity[]>();
  if (error) {
    throw error;
  }
  return data ?? [];
}
